const FEATURES = [
  {
    icon: 'ri-flashlight-line',
    title: '极速播放引擎',
    desc: '自研多线路智能切换播放技术，根据网络环境实时优化，高峰期也能流畅观影不缓冲，告别卡顿烦恼。',
    accent: false,
  },
  {
    icon: 'ri-hd-line',
    title: '高清画质呈现',
    desc: '支持标清到1080P超清多档画质自由切换，最新动作片、科幻巨制均提供高清版本，还原影院级视觉体验。',
    accent: true,
  },
  {
    icon: 'ri-refresh-line',
    title: '每日片源更新',
    desc: '专业片源团队全天候运作，每日上新最新电影资源。热门动作片、爆笑喜剧片院线下映后第一时间上线。',
    accent: false,
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500 mt-2">为什么选择97影视</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {FEATURES.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-50 border border-background-200/60 rounded-lg p-6 text-center hover:border-primary-500/30 transition-colors"
            >
              <div
                className={`w-12 h-12 rounded-xl flex items-center justify-center mx-auto mb-4 ${
                  feature.accent
                    ? 'bg-accent-500/15 text-accent-500'
                    : 'bg-primary-500/15 text-primary-500'
                }`}
              >
                <i className={`${feature.icon} text-xl`} />
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-2">{feature.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}